import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import styles from "../styles";
import CustomSelect from "../../globalno-dodavanje/CustomSelect";
import CustomSelectSimple from "../CustomSelectSimple";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";

const emptyRed = {
  dan: "",
  nepravilnosti: "",
  zaposlen: { id: -1, name: "" },
  mere: "",
  napomena: "",
};

const today = new Date().getDate();

function Dodavanje({ handleCancel, gradilisteId, godina, mesec, onRefresh }) {
  const [red, setRed] = useState({ ...emptyRed, dan: today });
  const [daniData, setDaniData] = useState([]);
  const [zaposleni, setZaposleni] = useState([]);
  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  const isCurrent =
    new Date().getMonth() + 1 == mesec && new Date().getFullYear() == godina;
  const brojDana = isCurrent ? today : new Date(godina, mesec, 0).getDate();
  const allDays = Array.from({ length: brojDana }, (_, i) => i + 1);

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija7/get_zaposleni_gradiliste.php`,
          {
            gradiliste_id: gradilisteId,
          },
        );
        if (data.status === 200) setZaposleni(data.zaposleni);
      } catch (e) {
        console.error(e);
      }
    };
    fetchLookups();
  }, [gradilisteId]);

  useEffect(() => {
    const fetchDani = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija7/get_dani.php`,
          {
            gradiliste_id: gradilisteId,
            godina,
            mesec,
          },
        );
        if (data.status === 200) {
          setDaniData(data.data);
          const postoji = data.data.find((d) => d.dan == today);
          if (postoji) {
            setRed({
              dan: postoji.dan,
              nepravilnosti: postoji.nepravilnosti || "",
              zaposlen: {
                id: postoji.user_id || -1,
                name: postoji.zaposleni_naziv || "",
              },
              mere: postoji.mere || "",
              napomena: postoji.napomena || "",
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    };
    fetchDani();
  }, [gradilisteId, godina, mesec]);

  const handleChange = (newValue, field) => {
    if (field === "dan") {
      const postoji = daniData.find((d) => d.dan == newValue);
      if (postoji) {
        setRed({
          dan: postoji.dan,
          nepravilnosti: postoji.nepravilnosti || "",
          zaposlen: {
            id: postoji.user_id || -1,
            name: postoji.zaposleni_naziv || "",
          },
          mere: postoji.mere || "",
          napomena: postoji.napomena || "",
        });
      } else {
        setRed({ ...emptyRed, dan: newValue });
      }
      return;
    }
    setRed((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleSacuvaj = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija7/save_dan.php`, {
        company_id: selectedMainEntity.company_id,
        gradiliste_id: gradilisteId,
        godina,
        mesec,
        dan: red.dan,
        nepravilnosti: red.nepravilnosti,
        user_id: red.zaposlen.id === -1 ? null : red.zaposlen.id,
        mere: red.mere,
        napomena: red.napomena,
      });
      if (data.status === 200) {
        onRefresh();
        handleCancel();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const isDisabled =
    !red.dan || red.zaposlen.id === -1 || !red.nepravilnosti || !red.mere;

  return (
    <div>
      <div style={{ display: "flex", gap: "10px" }}>
        <CustomSelectSimple
          label={dictionary["dan"]}
          allValues={allDays}
          selectedValue={red.dan}
          onSelectChange={(v) => handleChange(v, "dan")}
          style={{ width: "60px", maxHeight: "200px" }}
        />
        <div style={{ width: "25%" }}>
          <div style={styles.natpis}>{dictionary["nepravilnosti"]}</div>
          <input
            value={red.nepravilnosti}
            onChange={(e) => handleChange(e.target.value, "nepravilnosti")}
            style={{ ...styles.formInput, width: "100%" }}
          />
        </div>
        <CustomSelect
          label={dictionary["imeIPrezime"]}
          allValues={zaposleni}
          selectedValue={red.zaposlen}
          onSelectChange={(v) => handleChange(v, "zaposlen")}
        />
        <div style={{ width: "25%" }}>
          <div style={styles.natpis}>{dictionary["mere"]}</div>
          <input
            value={red.mere}
            onChange={(e) => handleChange(e.target.value, "mere")}
            style={{ ...styles.formInput, width: "100%" }}
          />
        </div>
        <div style={{ width: "25%" }}>
          <div style={styles.natpis}>{dictionary["napomena"]}</div>
          <input
            value={red.napomena}
            onChange={(e) => handleChange(e.target.value, "napomena")}
            style={{ ...styles.formInput, width: "100%" }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        <div onClick={handleCancel}>
          <Button activation={true} style={styles.button}>
            {dictionary["odustani"]}
          </Button>
        </div>
        <div
          onClick={isDisabled ? undefined : handleSacuvaj}
          style={{ opacity: isDisabled ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabled}
            activation={true}
            style={styles.button}
          >
            {dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Dodavanje;